import * as apps from 'app/common/constants/services'

const applications = [
  apps.APP_DNEVNIK,
  apps.APP_CAFETERIA,
  apps.APP_ACCESS,
  apps.APP_POLLS,
  apps.EXT_YACLASS,
] as const

// массив всех задействованных приложений
export default applications
